export default "__VITE_ASSET__CBdDWL9P__"